import { render } from "./NoOfFloorsCreating.vue?vue&type=template&id=7ba5e65a&ts=true"
import script from "./NoOfFloorsCreating.vue?vue&type=script&lang=ts"
export * from "./NoOfFloorsCreating.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__